export const BATCHES_UPDATE_SHIPPING_PAGE_LEFT_NAV = 'BATCHES_UPDATE_SHIPPING_PAGE_LEFT_NAV';
export const updateShippingPageLeftNav = (tabFilter) => ({
  type: BATCHES_UPDATE_SHIPPING_PAGE_LEFT_NAV,
  tabFilter,
});

export const BATCHES_UPDATE_ORDERS_PAGE_LEFT_NAV = 'BATCHES_UPDATE_ORDERS_PAGE_LEFT_NAV';
export const updateOrdersPageLeftNav = () => ({
  type: BATCHES_UPDATE_ORDERS_PAGE_LEFT_NAV,
});

export const GET_BATCH_MENU_DATA = 'GET_BATCH_MENU_DATA';
export const getBatchMenuData = () => ({
  type: GET_BATCH_MENU_DATA,
});

export const GET_BATCH_MENU_SUCCESS = 'GET_BATCH_MENU_SUCCESS';
export const getBatchMenuDataSuccess = (batchData, currentUserId) => ({
  type: GET_BATCH_MENU_SUCCESS,
  batchData,
  currentUserId,
});

export const TOGGLE_BATCH_NAV_MENU = 'TOGGLE_BATCH_NAV_MENU';
export const toggleBatchNavMenu = () => ({
  type: TOGGLE_BATCH_NAV_MENU,
});

export const UPDATE_BATCH_NAV_NAME = 'UPDATE_BATCH_NAV_NAME';
export const updateBatchNavName = (fulfillmentPlanSetId, name) => ({
  type: UPDATE_BATCH_NAV_NAME,
  fulfillmentPlanSetId,
  name,
});

export const LOAD_MORE_ACTIVE_BATCHES = 'BATCHES_NAV_LOAD_MORE_ACTIVE_BATCHES';
export const loadMoreActiveBatches = () => ({
  type: LOAD_MORE_ACTIVE_BATCHES,
});
